/**
 * The seven kinds of completed work, in the order staff see them.
 *
 * Keys are exactly the `completions` keys of GET /api/organisations/students
 * and /students/<id>/activity/summary, which always carry all seven as integers.
 * What counts as one completion of each kind is decided by the backend
 * (docs/features/organisations-activity.md), never here.
 */
export const COMPLETION_KINDS = [
  { key: 'writing', label: 'Writing' },
  { key: 'quiz', label: 'Quiz questions' },
  { key: 'practice', label: 'Practice' },
  { key: 'papers', label: 'Papers' },
  { key: 'interviews', label: 'Interviews' },
  { key: 'mastery', label: 'Mastery apps' },
  { key: 'cases', label: 'Cases' },
];
